import {
  KioskIntegration,
  KioskPlatform,
} from '@inter-ikea-gallery/integration';

export const useKioskIntegration = () => {
  const params = new URLSearchParams(window.location.href);
  let integration: KioskIntegration | null = null;
  let mode: KioskPlatform | undefined = undefined;

  if (
    params.get('ipexGallery') === 'true' ||
    params.get('origin') === 'upptacka'
  ) {
    mode = params.get('ipexGallery') === 'true' ? 'gallery' : 'upptacka';
    integration = new KioskIntegration({ debug: true, platform: mode });
  }

  const isUpptacka = mode === 'upptacka';
  const isGallery = mode === 'gallery';
  const isUpptackaOrIpexGallery = isGallery || isUpptacka;

  return { integration, isUpptacka, isGallery, isUpptackaOrIpexGallery };
};
